<template lang="pug">
    div(v-if="showEditWatchlistPopup" class="pa-4 popup-edit")
        div(class="popup-row text-right")
            v-icon(@click="closePopup()") mdi-close
        div(class="popup-row")
            label() {{ $t('Name') }}:
            input(type="text" v-model="localWatchlist.name")
        //- div(class="mt-2" style="height:25px; border:0px solid;")
            div(style="float:left; width:20%; border:0px solid;") Columns
            div(style="float:left; width:80%; border:0px solid;")
                div(class="mr-6" style="border:0px solid;") whatever...
                //- div {{ columnNames }}
        //- div(class="mt-2" style="height:180px; border:0px solid;")
            div(style="float:left; width:20%; border:0px solid;") Filter
            div(style="float:left; width:80%; border:0px solid;")
                div(style="height:180px; overflow-y:scroll;")
                    pre kul...
                    //- pre {{ filters }}
        //- div(class="mt-2" style="height:25px; border:0px solid;")
            div(style="float:left; width:20%; border:0px solid;") Sort
            div(style="float:left; width:80%; border:0px solid;")
        div(class="mt-5" style="border:0px solid;")
            div(style="float:left; width:50%; border:0px solid;")
                button(@click="deleteWatchlist(watchlist.watchlist_id)" class="btn-secondary" style="") {{ $t('Delete') }}
            div(class="text-right" style="float:left; width:50%; border:0px solid;")
                button(@click="saveWatchlist()" class="btn-primary" style="") {{ $t('Save') }}
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'EditWatchlistSettings',
    props: {
        showEditWatchlistPopup: Boolean,
        watchlist: Object
    },
    data() {
        return {
            localShowEditWatchlistPopup: false,
            localWatchlist: null,
            name: ''
        };
    },
    computed: {
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        },
        columnNames() {
            const columnNamesArray = Object.keys(JSON.parse(this.watchlist.filter));

            let columnNamesString = '';

            let counter = 0;

            for(const name of columnNamesArray) {
                counter += 1;
                columnNamesString += (columnNamesArray.length > counter) ? `${name},` : name;
            }

            return columnNamesString;
        },
        filters() {
            return JSON.parse(this.watchlist.filter);
        }
    },
    watch: {
        showEditWatchlistPopup() {
            if(this.showEditWatchlistPopup) {
                console.log('show');

                this.localWatchlist = JSON.parse(JSON.stringify(this.watchlist));
            }
        }
    },
    methods: {
        ...mapActions([
            'changeWatchlistName',
            'deleteWatchlistForUser'
        ]),
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        closePopup() {
            console.log('closePopup');

            this.localShowEditWatchlistPopup = false;
            this.$emit("closeEditWatchlistPopup", this.localShowEditWatchlistPopup);
        },
        async deleteWatchlist(watchlist_id) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                this.localShowEditWatchlistPopup = false;
                this.$emit("closeEditWatchlistPopup", this.localShowEditWatchlistPopup);

                return;
            }

            console.log(watchlist_id);

            const deleteWatchlistObject = {
                user_id: this.user_id,
                watchlist_id: watchlist_id
            };

            await this.deleteWatchlistForUser(deleteWatchlistObject);

            this.localShowEditWatchlistPopup = false;
            this.$emit("closeEditWatchlistPopup", this.localShowEditWatchlistPopup);
        },
        async saveWatchlist() {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                this.localShowEditWatchlistPopup = false;
                this.$emit("closeEditWatchlistPopup", this.localShowEditWatchlistPopup);

                return;
            }

            console.log('saveWatchlist');

            const payload = {
                user_id: this.user_id,
                name: this.localWatchlist.name,
                watchlist_id: this.localWatchlist.watchlist_id
            };

            console.log(payload);

            await this.changeWatchlistName(payload);

            this.localShowEditWatchlistPopup = false;
            this.$emit("closeEditWatchlistPopup", this.localShowEditWatchlistPopup);
        }
    }
}
</script>

<style scoped>

.popup-edit {
    border-radius: 8px;
    background-color: white;
    box-shadow: 8px 8px 25px grey;
    position: absolute;
    top: 30%;
    left: calc(50% - 175px);
    width: 350px;
    font-size: 15px;
    z-index: 10000000000;
}

.popup-edit .popup-row {

}

.popup-edit label,
.popup-edit input {
    width: 100%;
}

.popup-edit label {
    font-size: 12px;
    margin-bottom: 6px;
}

.popup-edit input {
    border: 1px solid rgba(20,75,77,1);
    border-radius: 4px;
    padding: 4px 6px;
}

.popup-edit input:focus,
.popup-edit input:active {
    background-color: rgba(244,244,244,1);
    border: 1px solid rgba(20,75,77,1);
    outline: none;
}


</style>
